__webpack_require__.O(0, ["app"], function() {
	["vendor.fortawesome","src_utils_fontawesome_js","src_utils_header_js"].map(__webpack_require__.E);
}, 5);